import * as harmonicas from './harmonicas';
import vissen from './visualizations';
import {COLOR_CYAAN} from "../../vocabulary";
import { aInfectieziekte, geboortezorg } from './pages/index'

const pages = [
{
	categorie:"basis",
	template:"specialvoorpagina",
	naam:"mini",
	titel:"Zó werkt de zorg-mini's",
	kleur:5,
	tekst:
		"Helder overzicht bij actuele en interessante thema's, dat is het doel van onze Zó werkt de zorg-mini's. De heldere informatie die je van Zó werkt de zorg gewend bent, maar dan in het kort.",
	links:[
		'mini-acute-zorg',
		'mini-ggz',
		'mini-ouderenzorg',
		'mini-a-infectieziekte',
		'mini-geboortezorg',
		]
},
{
	categorie:"mini",
	template:"intro",
	naam:"mini-acute-zorg",
	titel:"Zó werkt de zorg-mini: Acute zorg",
	kleur: 6,
	tekst:
		"In 2019 sloten meerdere ziekenhuizen hun spoedeisende hulp (SEH)-afdeling, wat leidde tot een discussie over de toegankelijkheid van acute zorg. Wat acute zorg precies is en hoe het zit met de toegang, lees je in deze mini.",
	links:[
		'wat-is-acute-zorg',
		'rijtijdSEH',
		'aantalSEHafdelingen',
		'colofon-acute-zorg'
		]
},
{
	categorie:"mini",
	template:"harmonica",
	naam:"wat-is-acute-zorg",
	titel:"Wat is acute zorg en wie doet wat?",
	kleur: 6,
	tekst: "",
	links: [
		'rijtijdSEH',
		'aantalSEHafdelingen'
		]
},
{
	categorie:"mini",
	template:"visualisatie",
	naam:"rijtijdSEH",
	titel:"Hoe ver is het naar de meest nabije SEH-afdeling?",
	kleur: 6,
	tekst: "",
	links: [
		'wat-is-acute-zorg',
		'aantalSEHafdelingen'
		]
},
{
	categorie:"mini",
	template:"visualisatie",
	naam:"aantalSEHafdelingen",
	titel:"Hoeveel SEH-afdelingen zijn er?",
	kleur: 6,
	tekst: "",
	links: [
		'wat-is-acute-zorg',
		'rijtijdSEH'
		]
},
{
	categorie:"mini",
	template:"harmonica",
	naam:"colofon-acute-zorg",
	titel:"Colofon",
	kleur: 6,
	tekst: "",
	links: []
},
	{
		categorie:"mini",
		template:"intro",
		naam:"mini-ggz",
		titel:"Zó werkt de zorg-mini: ggz",
		kleur:1,
		tekst:
			"De geestelijke gezondheidszorg (ggz) staat volop in de aandacht, mede door een discussie over de beschikbaarheid van zorg voor hoogcomplexe patiënten. Maar hoe is de ggz eigenlijk geregeld? Hoeveel geven we in Nederland uit aan geestelijke gezondheidszorg? En hoe staat het met het aantal 'bedden' in ggz-instellingen, nadat in 2012 werd afgesproken om zorg zoveel mogelijk thuis (ambulant) te bieden? Je leest het in deze mini.",
		links:
			['wat-is-ggz',
			'zorguitgaven-ggz',
			'aantal-ggz-bedden',
			'colofon-ggz']
	},
	{
		categorie:"mini",
		template:"harmonica",
		naam:"wat-is-ggz",
		titel:"Wat is de ggz en welke wet regelt wat?",
		kleur:1,
		tekst: "",
		links:
			[ 'zorguitgaven-ggz',
			'aantal-ggz-bedden']
	},
	{
		categorie:"mini",
		template:"visualisatie",
		naam:"zorguitgaven-ggz",
		titel:"Hoeveel geld geven we in Nederland uit aan geestelijke gezondheidszorg?",
		kleur:1,
		tekst: "",
		links:
			['wat-is-ggz',
			'aantal-ggz-bedden']
	},
	{
		categorie:"mini",
		template:"visualisatie",
		naam:"aantal-ggz-bedden",
		titel:"Hoeveel bedden hebben ggz-instellingen in Nederland beschikbaar voor geestelijke gezondheidszorg?",
		kleur:1,
		tekst: "",
		links:
			['wat-is-ggz',
			'zorguitgaven-ggz']
	},
	{
		categorie:"mini",
		template:"harmonica",
		naam:"colofon-ggz",
		titel:"Colofon",
		kleur:1,
		tekst: "",
		links: []
	},
	{
		categorie:"mini",
		template:"intro",
		naam:"mini-ouderenzorg",
		titel:"Zó werkt de zorg-mini: Ouderenzorg",
		kleur:3,
		tekst:
			"De komende decennia moeten we 'woekeren met schaarse middelen' in de ouderenzorg, aldus de commissie Toekomst zorg thuiswonende ouderen. Waarom deze noodkreet? De feiten over de ouderenzorg - bij ongewijzigd beleid - op een rij.",
		links:
			[
				'wat-is-ouderenzorg',
				'toezicht-ouderenzorg',
				'geld-ouderenzorg',
				'colofon-ouderenzorg'
			]
	},
	{
		categorie:"mini",
		template:"harmonica",
		naam:"wat-is-ouderenzorg",
		titel:"Wat is ouderenzorg en wat zijn relevante trends?",
		kleur: COLOR_CYAAN,
		tekst: "",
		links:
			[
				'toezicht-ouderenzorg',
				'geld-ouderenzorg'
			]
	},
	{
		categorie: "mini",
		template: "visualisatie",
		naam: "toezicht-ouderenzorg",
		titel: "Hoeveel ouderen hebben blijvend 24 uur per dag zorg en toezicht nodig?",
		kleur: COLOR_CYAAN,
		tekst: "",
		links:
			[
				'wat-is-ouderenzorg',
				'geld-ouderenzorg'
			]
	},
	{
		categorie: "mini",
		template: "visualisatie",
		naam: "geld-ouderenzorg",
		titel: "Hoeveel geld gaat naar de ouderenzorg?",
		kleur: COLOR_CYAAN,
		tekst: "",
		links:
			[
				'wat-is-ouderenzorg',
				'toezicht-ouderenzorg'
			]
	},
	{
		categorie:"mini",
		template:"harmonica",
		naam:"colofon-ouderenzorg",
		titel:"Colofon",
		kleur:COLOR_CYAAN,
		tekst: "",
		links: []
	},

	aInfectieziekte.intro,
	aInfectieziekte.watIsEenAInfectieziekte,
	aInfectieziekte.wieDoetWat,
	aInfectieziekte.dwingendeMaatregelen,
	aInfectieziekte.colofon,

	geboortezorg.intro,
	geboortezorg.watIsGeboortezorg,
	geboortezorg.aantalBevallingen,
	geboortezorg.uitgavenGeboortezorg,
	geboortezorg.colofon,
]

// loop over pages to add harmonicas and visualizations
pages.map(pagina => {
	if (pagina.template === "harmonica") {
		const harmonicaNaam = pagina.naam.replace(/-/g, "_");
		pagina.harmonica = harmonicas[harmonicaNaam];
	}
	if (pagina.template === "visualisatie") {
		const visualisatieNaam = pagina.naam.replace(/-/g, "_");
		pagina.vis = vissen[visualisatieNaam];
	}
	return pagina;
});

export default pages;
